export class EducationHistoryConfiguration {
  id: number;
  applicantElementId: number;
  instanceId: number;
  instructionsToApplicants: string;
  showSchoolName: boolean;
  requireSchoolName: boolean;
  showCityState: boolean;
  requireCityState: boolean;
  showDegreeStatus: boolean;
  requireDegreeStatus: boolean;
  showMajor: boolean;
  requireMajor: boolean;
  showFromToDates: boolean;
  requireFromToDates: boolean;
  showComments: boolean;
  requireComments: boolean;
}
